import { Node, NodeProps } from "@xyflow/react";
import { useSetAtom } from "jotai";
import {
  assetStepTitlePlaceholderTextAtom,
  DefaultNodeData,
} from "@zapier/canvas-state";

import { AssetNodeProps } from "../AssetNodeSkeleton/AssetNodeDeterminer";
import { AssetNodeSkeleton } from "../AssetNodeSkeleton";
import {
  DEFAULT_AGENT_NODE_BACKGROUND_COLOR,
  DEFAULT_AGENT_NODE_COLOR,
} from "@zapier/canvas-constants";
import { useAssetPreload } from "../../../../hooks/useAssetPreload";

export function AgentNode(
  props: NodeProps<Node<DefaultNodeData>> & AssetNodeProps,
) {
  const { isViewOnlyMode } = props;

  const handleMouseEnter = useAssetPreload({
    assetType: "agent",
    nodeData: props.data,
  });
  const getPlaceholder = useSetAtom(assetStepTitlePlaceholderTextAtom);
  const placeholder = getPlaceholder("agent");

  return (
    <AssetNodeSkeleton
      {...props}
      data={{
        ...props.data,
        color: props.data.color || DEFAULT_AGENT_NODE_COLOR,
      }}
      placeholder={isViewOnlyMode ? "" : placeholder}
      iconName="navCentral"
      backgroundColor={
        props.backgroundColor || DEFAULT_AGENT_NODE_BACKGROUND_COLOR
      }
      onMouseEnter={handleMouseEnter}
    />
  );
}
